/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
(function () {
  var WORKER_URL = 'https://trustpilot-reviews-worker.dev-53f.workers.dev';
  var TRUSTPILOT_PROFILE_URL = 'https://www.trustpilot.com/review/desktronic.com';

  var STAR_CUTOUT_PATH =
    'M8.00155 10.7831L10.4342 10.1689L11.4472 13.3035L7.99357 10.7831H8.00155ZM13.6007 6.7312H9.3176L8.00155 2.69531L6.68549 6.7312H2.40234L5.87194 9.22772L4.55588 13.2636L8.02547 10.7671L10.1631 9.23569L13.6167 6.73918L13.6007 6.7312Z';

  function starsMarkup(rating) {
    var filledColor = rating >= 5 ? '#00B67A' : '#73CF11';
    var emptyColor = '#DCDCE6';
    var out = '';
    for (var i = 1; i <= 5; i++) {
      var bg = i <= rating ? filledColor : emptyColor;
      out +=
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" class="icon-star" aria-hidden="true">' +
        '<path d="M16 0H0V16H16V0Z" fill="' +
        bg +
        '"/>' +
        '<path d="' +
        STAR_CUTOUT_PATH +
        '" fill="white"/>' +
        '</svg>';
    }
    return out;
  }

  function badgeMarkup(badgeText) {
    return (
      '<div class="social-proof__badge">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">' +
      '<path d="M7.49414 0.984375L9.27734 0.972656L10.0068 2.61621L11.5137 3.58008L11.248 5.36133L12 6.99512L10.8232 8.34961L10.5811 10.1348L8.86719 10.6309L7.70801 12L6 11.4814L4.29199 12L3.13281 10.6309L1.41895 10.1348L1.17676 8.34961L0 6.99512L0.751953 5.36133L0.486328 3.58008L1.99316 2.61621L2.72266 0.972656L4.50586 0.984375L6 0L7.49414 0.984375ZM8.27246 4.28809C8.07758 4.10273 7.77054 4.11189 7.58691 4.30859L5.2002 6.86914L4.41309 6.02539C4.22945 5.82853 3.92247 5.8194 3.72754 6.00488C3.53299 6.19041 3.52361 6.50043 3.70703 6.69727L4.84766 7.91992C5.03903 8.12475 5.36136 8.12476 5.55273 7.91992L8.29297 4.98047C8.47638 4.78349 8.46735 4.47353 8.27246 4.28809Z" fill="#319EAE"/>' +
      '</svg><span class="social-proof__badge-text">' +
      badgeText +
      '</span></div>'
    );
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function cardShellMarkup(review, badgeText) {
    var reviewUrl = review.id
      ? 'https://www.trustpilot.com/reviews/' + review.id
      : TRUSTPILOT_PROFILE_URL;

    return (
      '<a class="social-proof__card swiper-slide" href="' +
      reviewUrl +
      '" target="_blank" rel="noopener">' +
      '<div class="social-proof__card-frame">' +
      '<div class="social-proof__card-testimonial">' +
      '<div class="social-proof__card-meta">' +
      '<div class="social-proof__card-stars">' +
      starsMarkup(review.rating) +
      '</div>' +
      (review.author ? '<p class="social-proof__card-name">' + escapeHtml(review.author) + '</p>' : '') +
      '</div>' +
      '<p class="social-proof__card-text"></p>' +
      '</div>' +
      (review.verified ? badgeMarkup(badgeText) : '') +
      '</div>' +
      '</a>'
    );
  }

  function skeletonMarkup() {
    var out = '';
    for (var i = 0; i < 4; i++) {
      out +=
        '<div class="social-proof__card social-proof__card--skeleton swiper-slide" aria-hidden="true">' +
        '<div class="social-proof__card-frame">' +
        '<div class="social-proof__skeleton-line social-proof__skeleton-line--stars"></div>' +
        '<div class="social-proof__skeleton-line social-proof__skeleton-line--name"></div>' +
        '<div class="social-proof__skeleton-line"></div>' +
        '<div class="social-proof__skeleton-line"></div>' +
        '<div class="social-proof__skeleton-line social-proof__skeleton-line--short"></div>' +
        '</div>' +
        '</div>';
    }
    return out;
  }

  function fitCardText(el, fullText, readMoreLabel) {
    var readMoreHtml = ' <span class="social-proof__read-more">' + escapeHtml(readMoreLabel) + '</span>';

    function render(text, withReadMore) {
      el.innerHTML = escapeHtml(text) + (withReadMore ? readMoreHtml : '');
    }

    render(fullText, false);
    if (el.scrollHeight <= el.clientHeight + 1) return;

    var words = fullText.split(' ');
    var lo = 0;
    var hi = words.length;
    var best = 1;

    while (lo <= hi) {
      var mid = Math.floor((lo + hi) / 2);
      var candidate = words.slice(0, mid).join(' ') + '...';
      render(candidate, true);
      if (el.scrollHeight <= el.clientHeight + 1) {
        best = mid;
        lo = mid + 1;
      } else {
        hi = mid - 1;
      }
    }

    render(words.slice(0, best).join(' ') + '...', true);
  }

  function renderCards(track, reviews, badgeText, readMoreLabel) {
    track.innerHTML = reviews.map(function (review) {
      return cardShellMarkup(review, badgeText);
    }).join('');

    var textEls = track.querySelectorAll('.social-proof__card-text');
    textEls.forEach(function (el, i) {
      fitCardText(el, reviews[i].text || '', readMoreLabel);
    });

    if (typeof window.initSocialProofSwiper === 'function') {
      window.initSocialProofSwiper();
    }
  }

  function initSection(section) {
    var track = section.querySelector('[data-social-proof-track]');
    if (!track) return;

    var lang = section.dataset.lang || 'lt';
    var badgeText = section.dataset.badgeText || 'Verified buyer';
    var readMoreLabel = section.dataset.readMoreText || 'Read more';
    var previousContent = track.innerHTML;
    track.innerHTML = skeletonMarkup();

    fetch(WORKER_URL + '?language=' + encodeURIComponent(lang))
      .then(function (res) {
        if (!res.ok) throw new Error('Bad response');
        return res.json();
      })
      .then(function (data) {
        if (!data.reviews || !data.reviews.length) {
          track.innerHTML = previousContent;
          return;
        }

        section._socialProofReviews = data.reviews;
        section._socialProofBadgeText = badgeText;
        section._socialProofReadMore = readMoreLabel;

        renderCards(track, data.reviews, badgeText, readMoreLabel);
      })
      .catch(function () {
        track.innerHTML = previousContent;
      });
  }

  function refitAllSections() {
    document.querySelectorAll('[data-social-proof-track]').forEach(function (track) {
      var section = track.closest('section');
      if (!section || !section._socialProofReviews) return;
      renderCards(
        track,
        section._socialProofReviews,
        section._socialProofBadgeText,
        section._socialProofReadMore
      );
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refitAllSections, 200);
  });

  document.querySelectorAll('[data-social-proof-track]').forEach(function (track) {
    initSection(track.closest('section'));
  });
})();